import axios from "axios";
import CryptoJS from "crypto-js";

export const baseUrl = "https://app1.crazzyhub.com/";
// export const baseUrl = "http://192.168.1.71:9098/";
// export const baseUrl = "http://122.163.177.178:4545/";
// export const baseUrl = "https://crazylab.appvedas.com/";
// export const baseUrl = "http://192.168.20.63:4545/";

// const baseURL =
//   process.env.NODE_ENV === "production" ? baseUrl : baseUrlLocal;

// const AES_SECRET_KEY = "tnd3w9D+K0MktyzSogSrVw==";
// const AES_IV_KEY = "QK2BnYP6GbQ5Q63SfES5ZA==";

const AES_SECRET_KEY = "9QEdROYBIdNkFvQlFoi6aA=="; // Base64
const AES_IV_KEY = " uvzyV3WGenBPjOvpaPTZZA==";

const axiosInstance = axios.create({
  baseURL: baseUrl,
});
const decryptData = (encryptedData) => {
  try {
    const key = CryptoJS.enc.Base64.parse(AES_SECRET_KEY);
    const iv = CryptoJS.enc.Base64.parse(AES_IV_KEY);
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    console.error("Decryption error:", err);
    return encryptedData;
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Token");
    config.headers = {
      Authorization: token,
      Token: token,
      ...config.headers,
    };
    return config;
  },
  (err) => Promise.reject(err),
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (typeof response.data === "string") {
      response.data = decryptData(response.data);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
